import { CountryCode } from 'types/tenants/country-code';
import { DropdownItem } from 'types/dropdown-item';
import { LanguageCode } from 'types/tenants/language-code';
import { Tenant } from 'types/tenants/tenant';
import { NmvsProvider } from 'types/nmvs-provider';

export const initialState: SettingsState = {
  tenantIdExists: undefined,
  tenant: {
    id: '',
    countryCode: CountryCode.Ireland,
    language: LanguageCode.Unknown,
    nmvsProvider: NmvsProvider.Unknown,
    customSettings: {},
    hasEnterpriseLogin: true
  },
  languageOptions: [
    {
      text: 'English',
      value: LanguageCode.English
    },
    {
      text: 'Français',
      value: LanguageCode.French
    },
    {
      text: 'Deutsch',
      value: LanguageCode.Deutsch
    },
    {
      text: 'Nederlandse',
      value: LanguageCode.Nederlandse
    },
    {
      text: 'Español',
      value: LanguageCode.Spanish
    }
  ],
  isProcessing: false,
  errorMessage: ''
};

export interface SettingsState {
  tenantIdExists?: boolean;
  tenant: Tenant;
  languageOptions: DropdownItem[];
  isProcessing: boolean;
  errorMessage: string;
}



// WEBPACK FOOTER //
// ./src/pages/settings/state.ts